import { useCallback, useState } from 'react';
import { SocialShare } from '../SocialShare/SocialShare';
import { socials } from '../socials';
import {
  AbsoluteWrapper,
  ExpandButton,
  IconWrapper,
  ShareContainer,
  StyledCloseSocials,
  StyledExpandIcon,
} from './StickyShareArticle.styles';
import { StickyShareArticleProps } from './StickyShareArticle.types';

export const StickyShareArticle: React.FC<StickyShareArticleProps> = ({
  link,
  textToShare,
  visible = true,
}) => {
  const [mobileVisible, setMobileVisible] = useState(false);

  const handleClick = useCallback(() => {
    setMobileVisible((prev) => !prev);
  }, []);

  return (
    <AbsoluteWrapper visible={visible}>
      <ShareContainer>
        {socials.map((social) => {
          if (social.name === 'Link') {
            const icon = social.icon as (
              articleLink: string,
              hoverColor: string,
            ) => React.ReactElement;

            return (
              <IconWrapper key={`${social.name}_${link}`} mobileVisible={mobileVisible}>
                {icon(link, social.color)}
              </IconWrapper>
            );
          }
          return (
            <IconWrapper key={`${social.name}_${link}`} mobileVisible={mobileVisible}>
              <SocialShare
                icon={social.icon}
                socialLink={social.socialLink}
                textPrefix={social.textPrefix}
                articleLink={link}
                text={textToShare}
                hoverColor={social.color}
              />
            </IconWrapper>
          );
        })}
        <ExpandButton onClick={handleClick} type="button">
          <StyledCloseSocials display={mobileVisible} />{' '}
          <StyledExpandIcon display={!mobileVisible} />
        </ExpandButton>
      </ShareContainer>
    </AbsoluteWrapper>
  );
};
